import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

import { useUserStore } from '@/store/modules/user'
import { useAppStore } from '@/store/modules/app'
import { storeToRefs } from 'pinia'
import personalcenterLayout from '@/views//personalcenter/layout.vue'
import registerLayout from '@/views/register/layout/index.vue'
import checkoutLayout from '@/views/checkout/layout.vue'
const routes = [
  {
    path: '/',
    name: 'registration-root',
    component: registerLayout,
    redirect: '/',
    children: [
      {
        path: '/',
        name: 'index',
        component: () => import('@/views/register/home/index.vue'),
        meta: {
          ignore: true,
        },
      },

      {
        path: 'personal',
        name: 'personal',
        component: () => import('@/views/register/personal/index.vue'),
        meta: {},
      },

      {
        path: 'survey',
        name: 'survey',
        component: () => import('@/views/register/survey/index.vue'),
        meta: {},
      },

      {
        path: 'ticket',
        name: 'ticket',
        component: () => import('@/views/register/ticket/index.vue'),
        meta: {},
      },

      {
        path: 'colleague',
        name: 'colleague',
        component: () => import('@/views/register/colleague/index.vue'),
        meta: {},
      },

      {
        path: 'payment',
        name: 'payment',
        component: () => import('@/views/register/payment/index.vue'),
        meta: {},
      },

      {
        path: 'confirmation',
        name: 'confirmation',
        component: () => import('@/views/register/confirmation/index.vue'),
        meta: {},
      },
    ],
  },
  {
    path: '/personalcenter',
    name: 'personalcenter-root',
    component: personalcenterLayout,
    redirect: '/personalcenter/confirmation',
    children: [
      {
        path: 'confirmation',
        name: 'personalcenter-confirmation',
        component: () => import('@/views/personalcenter/confirmation/index.vue'),
      },
      {
        path: 'personal',
        name: 'personalcenter-personal',
        component: () => import('@/views/personalcenter/personal/index.vue'),
      },
      {
        path: 'order',
        name: 'personalcenter-order',
        component: () => import('@/views/personalcenter/order/index.vue'),
      },
      {
        path: 'ticket',
        name: 'personalcenter-ticket',
        component: () => import('@/views/personalcenter/ticket/index.vue'),
      },
      {
        path: 'colleague',
        name: 'personalcenter-colleague',
        component: () => import('@/views/personalcenter/colleague/index.vue'),
      },
    ],
  },

  {
    path: '/checkout',
    name: 'checkout-root',
    component: checkoutLayout,
    redirect: '/',
    children: [
      {
        path: '',
        name: 'checkout-index',
        component: () => import('@/views/checkout/index/index.vue'),
        meta: {},
      },
      {
        path: 'payment',
        name: 'checkout-payment',
        component: () => import('@/views/checkout/payment/index.vue'),
        meta: {},
      },
      {
        path: 'confirmation',
        name: 'checkout-confirmation',
        component: () => import('@/views/checkout/confirmation/index.vue'),
        meta: {},
      },
    ],
  },

  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    return { x: 0, y: 0 }
  },
})

export function setupRouter(app) {
  app.use(router)
  return router
}

router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  const appStore = useAppStore()
  const { token, getUserInfo, logout } = userStore
  //读取用户信息
  const { event } = appStore
  if (event.Config.Flow&&(event.Config.Flow == 'payment' || event.Config.Flow.toLocaleLowerCase() == 'payment')) {
    if (!['checkout-index','checkout-payment','checkout-confirmation'].includes(to.name)) {
      handleRoute('checkout-index', to, next)
    } else {
      handleRoute(null, to, next)
    }
  } else {
    handleRoute(null, to, next)
  }
})

const handleRoute = (name, to, next) => {
  const { event } = storeToRefs(useAppStore())
  const { token: uid } = storeToRefs(useUserStore())
  let query = {}
  if (event && event.value) {
    if (event.value.Track) {
      query.i = event.value.Track
    } else {
      query.v = event.value.ID
    }
  }
  if (uid && uid.value && to.name !== 'index') {
    query.uid = uid.value
  }
  let _v = (to.query.v && to.query.v.length > 0) || (to.query.i && to.query.i.length > 0)
  let _uid =to.query.hasOwnProperty('uid');// to.query.uid && to.query.uid.length > 0
  if (_v && (_uid || !query.uid)) {
    if (name) {
      next({ name: name })
    } else {
      next()
    }
  } else {
    if (query.v || query.i) {
      if (name) {
        next({ name: name, query: { ...to.query, ...query } })
      } else {
        next({ ...to, query: { ...to.query, ...query } })
      }
    } else {
      if (name) {
        next({ name: name })
      } else {
        next()
      }
    }
  }
}

export default router
